import {
  infoFetchGetDiseñoCurricularI,
  makeDiseñoCurricular,
  CreateDiseñoCurricularJsonDto,
  UpdateDiseñoCurricularJsonDto,
} from "dtos/diseñoCurricular";
import { PresignedUrlResponse, infoFetchGetUrlPrefirmadaI } from "dtos/normativa";
import { ENDPOINTS } from "./endpoints";
import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { servicesUtils } from "./utils/services.utils";

export const getDiseñosCurriculares = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchGetDiseñoCurricularI>
  >({
    method: "GET",
    uri: ENDPOINTS.DISEÑOS_CURRICULARES,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  const elementosFormated = response.elementos.map((ctElemento) =>
    makeDiseñoCurricular(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const getDiseñoCurricularCount = async (params: any) => {
  console.log(params);
  const response = await sendRequest<number>({
    method: "GET",
    uri: ENDPOINTS.DISEÑOS_cURRICULARES_COUNT,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return response;
};

export const postDiseñoCurricular = async ({
  params,
  images,
}: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetDiseñoCurricularI>({
    method: "POST",
    uri: ENDPOINTS.DISEÑOS_CURRICULARES,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  return makeDiseñoCurricular(response);
};

export const putDiseñoCurricular = async ({
  params,
  images,
}: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetDiseñoCurricularI>({
    method: "PUT",
    uri: ENDPOINTS.DISEÑOS_CURRICULARES,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  return makeDiseñoCurricular(response);
};

export const deleteDiseñoCurricular = async (id: any) => {
  const response = await sendRequest({
    method: "DELETE",
    uri: ENDPOINTS.DISEÑOS_CURRICULARES + "/" + id,
  });
  return response;
};

// Solicita URLs prefirmadas al endpoint propio de disenio-curricular
export const getUrlPrefirmadaDC = async (documento: infoFetchGetUrlPrefirmadaI) => {
  const response = await sendRequest<PresignedUrlResponse[]>({
    method: "POST_JSON",
    uri: ENDPOINTS.DISEÑOS_CURRICULARES + "/url-prefirmada",
    params: documento,
  });
  return response;
};

// Confirma la creacion en el backend con las keys de S3 (flujo V2)
export const postDiseñoCurricularV2 = async (dto: CreateDiseñoCurricularJsonDto) => {
  // TODO: Log de desarrollo, eliminar luego de validar en DEV
  console.log("postDiseñoCurricularV2", dto);
  const response = await sendRequest<infoFetchGetDiseñoCurricularI>({
    method: "POST_JSON",
    uri: ENDPOINTS.DISEÑOS_CURRICULARES + "/v2",
    params: dto,
  });
  return makeDiseñoCurricular(response);
};

// Confirma la edicion en el backend con las keys de S3 (flujo V2)
export const putDiseñoCurricularV2 = async (dto: UpdateDiseñoCurricularJsonDto) => {
  // TODO: Log de desarrollo, eliminar luego de validar en DEV
  console.log("putDiseñoCurricularV2", dto);
  const response = await sendRequest<infoFetchGetDiseñoCurricularI>({
    method: "PUT_JSON",
    uri: ENDPOINTS.DISEÑOS_CURRICULARES + "/v2",
    params: dto,
  });
  return makeDiseñoCurricular(response);
};
